import * as d3 from "d3";
import { DateTime } from "luxon";
import { getCountryId, getProvinceId, getFullProvinceId, parseProvincesAndCountries } from "./locations";
import { getLastItem } from "./utils";
import {
  UNCERTAIN_THRESHOLD,
  UNCERTAIN_PCT_THRESHOLD,
  EARLIEST_DATA_DATE,
  PROVINCE_SEPARATOR,
  MAX_PREDICTION_SUBVARIANTS,
  QUALITY_THRESHOLD
} from "./constants";

let ALL_VARIANTS, ALL_LINEAGES;

let lineageToVariantLookup = {};
let variantPrimaryLineages = {};
let mostRecentDataDate, updateDate;
let processedData;

export function fetchData(countries, dataInitialize, errorCallback, setUpdateDate) {

  //let lineageCounts, totalCounts;

  let parsedCountries = parseProvincesAndCountries(countries);

  // console.log('fetchData -> countries', countries);
  // console.log('fetchData -> parsed countries', parsedCountries);

  //let location = parsedCountries[0];

  let promises = [];

  parsedCountries.forEach(location => {

    if (location.isProvince) {
      promises.push(
        fetch(`https://wopr.fathom.info/query/bin=week,lineage,province/country=${ location.country }/province=${ location.province }/cleandates/date=${ EARLIEST_DATA_DATE.toISODate() }:`)
          .then(res => res.json())
          .then(data => {
            location.lineageCounts = data;
          })
      );
      promises.push(
        fetch(`https://wopr.fathom.info/query/bin=week,province/country=${ location.country  }/province=${ location.province }/cleandates/date=${ EARLIEST_DATA_DATE.toISODate() }:`)
          .then(res => res.json())
          .then(data => {
            location.totalCounts = data;
          })
      );
    } else {
      promises.push(
        fetch(`https://wopr.fathom.info/query/bin=week,lineage,country/country=${ location.country }/cleandates/date=${ EARLIEST_DATA_DATE.toISODate() }:`)
          .then(res => res.json())
          .then(data => {
            location.lineageCounts = data;
          })
      );
      promises.push(
        fetch(`https://wopr.fathom.info/query/bin=week,country/country=${ location.country }/cleandates/date=${ EARLIEST_DATA_DATE.toISODate() }:`)
          .then(res => res.json())
          .then(data => {
            location.totalCounts = data;
          })
      );
    }
  });

  // variants

  promises.push(
    fetch(`https://wopr.fathom.info/datadict/variant/`)
      .then(res => res.json())
      .then(data => {
        ALL_VARIANTS = data.variants;

        //console.log('ALL_VARIANTS', ALL_VARIANTS);

      })
  );


  // lineages
  promises.push(

    fetch(`https://wopr.fathom.info/datadict/lineage/`)
      .then(res => res.json())
      .then(data => {
        ALL_LINEAGES = data.lineages;

        //console.log('ALL_LINEAGES', ALL_LINEAGES);

      })

  );


  // GISAID udpate date
  promises.push(
    // Pre-Fetch update date, needed to calculate chart filter dates as well
    fetch(`https://wopr.fathom.info/metadata/`)
      .then(res => res.json())
      .then(data => {
        updateDate = DateTime.fromISO(data.metadata);
        setUpdateDate();
      })
  );

  Promise.all(promises)
    .then(() => {

      processActualsData(parsedCountries, dataInitialize);

    })
    .catch(err => {
      errorCallback(err);
    });
}

function processActualsData(countries, dataInitialize) {
  lineageToVariantLookup = processVariants(ALL_VARIANTS, ALL_LINEAGES);

  let dataKeyedByWeek = {};
  let countsKeyedByWeek = {};

  // Countries is already parsed when it comes in


  //let parsedCountries = parseProvincesAndCountries(countries);
  //let location = parsedCountries[0];

  countries.forEach(location => {

    for (const date in location.totalCounts.bins) {

      // let lineageBin = lineageCounts.bins[date];
      // let totalCountsBin = totalCounts.bins[date];

      let lineageBin = location.lineageCounts.bins[date];
      let totalCountsBin = location.totalCounts.bins[date];

      let weekDate = DateTime.fromISO(date);

      dataKeyedByWeek[weekDate.toISODate()] = dataKeyedByWeek[weekDate.toISODate()] || {};
      let weekBin = dataKeyedByWeek[weekDate.toISODate()];

      for (const lineage in lineageBin) {
        if (lineageBin && lineageBin[lineage]) {

          weekBin[lineage] = weekBin[lineage] || {};

          // countries.forEach(location => {

          let locationKey = location.isProvince ? location.province : location.country;

          let num = 0;
          if (lineageBin[lineage][locationKey]) {
            num = lineageBin[lineage][locationKey];
          }

          weekBin[lineage][locationKey] = weekBin[lineage][locationKey] || {num:0, pct:0, sequencesCount:0};
          weekBin[lineage][locationKey].num += num;

          //});

        }
      }

      //let locations = countries;

      //countries.forEach(location => {

      // let lineageBin = location.lineageCounts.bins[date];
      // let totalCountsBin = location.totalCounts.bins[date];

      let locationKey = location.isProvince ? location.province : location.country;

      let sequencesCount = totalCountsBin[locationKey];

      countsKeyedByWeek[weekDate.toISODate()] = countsKeyedByWeek[weekDate.toISODate()] || {};
      countsKeyedByWeek[weekDate.toISODate()][locationKey] = countsKeyedByWeek[weekDate.toISODate()][locationKey] || 0;
      countsKeyedByWeek[weekDate.toISODate()][locationKey] += sequencesCount;

    //});
    }

  });



  for (const date in dataKeyedByWeek) {

    let weekBin = dataKeyedByWeek[date];
    let totalCountsBin = countsKeyedByWeek[date];

    for (const variant in weekBin) {
      for (const location in weekBin[variant]) {
        weekBin[variant][location].sequencesCount = totalCountsBin[location];
        weekBin[variant][location].pct = weekBin[variant][location].num / weekBin[variant][location].sequencesCount;
      }
    }

  }

  // console.log(dataKeyedByWeek);
  // console.log(countsKeyedByWeek);

  // Decompose the keyed data into timeseries arrays
  let data = {locations:[]};

  countries.forEach(location => {

    let locationKey = location.isProvince ? location.province : location.country;
    let location_id = location.isProvince ? location.fullId : location.countryId;

    let d = {
      ...location,
      //variant : variant,
      location : locationKey,
      location_id : location_id,
      data : [],
      weeklyData : [],
      dailyData : [],
      weeklyPredictionData : [],
      dailyPredictionData : [],

      //weeklyVariants : [],
      sequencesTotal : 0
    };

    for (const dateKey in dataKeyedByWeek) {

      let dataPt = {
        date: DateTime.fromISO(dateKey),
        sequencesCount : 0
      }

      for (const variant in dataKeyedByWeek[dateKey]) {

        if (dataKeyedByWeek[dateKey][variant] && dataKeyedByWeek[dateKey][variant][locationKey]) {

          dataPt[variant] = dataKeyedByWeek[dateKey][variant][locationKey];
          dataPt.sequencesCount = dataKeyedByWeek[dateKey][variant][locationKey].sequencesCount;

        }
      }

      d.weeklyData.push(dataPt);

    }

    d.weeklyData.sort((a, b) => a.date.diff(b.date));


    // Fill in any missing dates

    let firstDate = d.weeklyData[0];
    if (firstDate) {
      firstDate = firstDate.date;
    }
    let lastDate = getLastItem(d.weeklyData).date;

    let weeks = lastDate.diff(firstDate, ['weeks']).values.weeks;
    for (let x = 1; x < weeks; x++) {
      let dateToCheck = firstDate.plus({weeks:x});

      if (!d.weeklyData.find(wd => wd.date.toISODate() === dateToCheck.toISODate())) {
        d.weeklyData.push({
          date:dateToCheck,
          sequencesCount:0
        });
      }
    }

    // Sort any made up dates in
    d.weeklyData.sort((a, b) => a.date.diff(b.date));
    d.weeklyData.forEach(dataPt => {
      d.sequencesTotal += dataPt.sequencesCount;
    });


    checkUncertainty(d.weeklyData, d.sequencesTotal);

    data.locations.push(d);
  });

  // Get most recent dates

  data.locations.forEach(d => {

    let lastDate = getLastItem(d.weeklyData).date;

    mostRecentDataDate =  null;

    if (!mostRecentDataDate) {
      mostRecentDataDate = lastDate;
    } else {
      //console.log(mostRecentDataDate.diff(lastDate, 'days').days);
      if (mostRecentDataDate.diff(lastDate, 'days').days < 0) {
        mostRecentDataDate = lastDate;
      }
    }
  });

  // console.log(data);

  dataInitialize(data);
}

// We sort the set of valid lineages by their totals, to figure out which set
// we send to the predict api
function getSubvariantsSortedByTotals(subvariants, subvariantTotalsKeyed) {

  let sortedSubvariants = [];

  let subvariantTotals = [];
  for (let lineage in subvariantTotalsKeyed) {
    subvariantTotals.push({
      ...subvariantTotalsKeyed[lineage],
      lineage:lineage
    });
  }
  subvariantTotals.sort((a, b) => b.num - a.num);

  // console.log('subvTotals', subvariantTotals);

  subvariantTotals.forEach(subv => {
    if (subvariants.includes(subv.lineage)) {
      sortedSubvariants.push(subv.lineage);
    }
  });

  return sortedSubvariants;

}

export function fetchPredictions(countries, dataInitialize, data, lineageThreshold, errorCallback) {

  let { validLineages } = getValidLineages(data, lineageThreshold);

  //console.log(validLineages);

  let parsedCountries = parseProvincesAndCountries(countries);

  //console.log(countries, parsedCountries);

  let promises = [];

  parsedCountries.forEach((location, dataIndex) => {

    //let location = parsedCountries[0];

    // console.log(location);

    let subvariants = data.locations[dataIndex].validLineages.filter(sv => !sv.match(/other/gi) && sv !== "");

    let sortedSubvariants = getSubvariantsSortedByTotals(subvariants, data.locations[dataIndex].subvariantTotals);


    data.locations[dataIndex].predictionSubvariants = sortedSubvariants.slice(0, MAX_PREDICTION_SUBVARIANTS);
    let predictionSubvariants = data.locations[dataIndex].predictionSubvariants.join(',');

    // console.log(data.locations[dataIndex]);
    // console.log(sortedSubvariants.slice(0, MAX_PREDICTION_SUBVARIANTS));

    let dailyPredictUrl, weeklyPredictUrl;
    if (location.isProvince) {

      dailyPredictUrl = `https://wopr.fathom.info/predict/lineage=${ predictionSubvariants }&country=${ location.country }&province=${ location.province }&exclusive`;
      weeklyPredictUrl = `https://wopr.fathom.info/predict/lineage=${ predictionSubvariants }&country=${ location.country }&province=${ location.province }&exclusive&week`;

    } else {

      dailyPredictUrl = `https://wopr.fathom.info/predict/lineage=${ predictionSubvariants }&country=${ location.country }&exclusive`;
      weeklyPredictUrl = `https://wopr.fathom.info/predict/lineage=${ predictionSubvariants }&country=${ location.country }&exclusive&week`;

    }

    promises.push(
      fetch(dailyPredictUrl)
        .then(res => res.json())
        .then(pdata => {
          if (pdata.status === 'success') {
            let d = processPredictionsData(pdata, data, subvariants);
            data.locations[dataIndex].dailyData = d.proportionsData;
            data.locations[dataIndex].dailyPredictionData = d.predictionData;
          } else {
            data.locations[dataIndex].noDailyPredictionData = true;
          }
          // } else {
          //   throw(`Predict API weekly error: ${ pdata.status } : ${ pdata.error }`);
          // }
        })
        .catch(err => {
          data.locations[dataIndex].noDailyPredictionData = true;
        })
    );
    promises.push(
      fetch(weeklyPredictUrl)
        .then(res => res.json())
        .then(pdata => {
          if (pdata.status === 'success') {
            let d = processPredictionsData(pdata, data, subvariants);
            data.locations[dataIndex].weeklyPredictionData = d.predictionData;
          } else {
            data.locations[dataIndex].noWeeklyPredictionData = true;
          }
          // } else {
          //   throw(`Predict API daily error: ${ pdata.status } : ${ pdata.error }`);
          // }
        })
        .catch(err => {
          data.locations[dataIndex].noWeeklyPredictionData = true;
        })
    );

  });

  Promise.all(promises).then(() => {
    dataInitialize();
  }).catch(err => {
    console.error(err);
    errorCallback();
    dataInitialize();
  });
}

function processPredictionsData(pdata, data, subvariants) {
  //console.log(pdata);

  let processedData = {};

  let predictionsKeyedByDate = {};
  let proportionsKeyedByDate = {};
  //let predictionsKeyedByWeek = {};

  let proportions = pdata.data.proportions_per_day;

  proportions.date.forEach((dateKey, index) => {
    let date = DateTime.fromISO(dateKey);

    proportionsKeyedByDate[date.toISODate()] = proportionsKeyedByDate[date.toISODate()] || {
      date: date
    };

    subvariants.forEach(sv => {

      let subvariant = proportions[`${ sv.toLowerCase() }_proportion`];
      let subv_sequences = proportions[`${ sv.toLowerCase() }_sequences`];
      if (subvariant) {

        proportionsKeyedByDate[date.toISODate()][sv] = {
          'pct' : subvariant[index],
          'num' : subv_sequences[index]
        }

      }

      if (proportions['other_proportion']) {
        proportionsKeyedByDate[date.toISODate()]['other'] = {
          'pct' : proportions['other_proportion'][index],
          'num' : proportions['other_sequences'][index]
        }
      }

    });

  });

  processedData.proportionsData = Object.values(proportionsKeyedByDate);
  processedData.proportionsData.sort((a, b) => a.date.diff(b.date));




  // Now, predictions

  let predictions = pdata.data.predictions;

  predictions.date.forEach((dateKey, index) => {

    let date = DateTime.fromISO(dateKey);
    // let weekDate = d3.timeWeek(DateTime.fromISO(dateKey));
    // weekDate = DateTime.fromJSDate(new Date(weekDate));

    predictionsKeyedByDate[date.toISODate()] = predictionsKeyedByDate[date.toISODate()] || {
      date: date,
      sequencesCount : 0,
      isPrediction: true
    };
    let dayBin = predictionsKeyedByDate[date.toISODate()];

    // predictionsKeyedByWeek[weekDate.toISODate()] = predictionsKeyedByWeek[weekDate.toISODate()] || {
    //   date: weekDate,
    //   sequencesCount : 0,
    //   isPrediction : true
    // };
    // let weekBin = predictionsKeyedByWeek[weekDate.toISODate()];


    [...subvariants, 'other'].forEach(sv => {

      let subvariant = predictions[sv.toLowerCase()];
      if (subvariant) {

        dayBin[sv] = {
          'estimate' : subvariant[index][0],
          'pct'   : subvariant[index][0], // used for stack charts
          'lower' : subvariant[index][1],
          'upper' : subvariant[index][2],
          'stderr' : subvariant[index][3],
          'isPrediction' : true
        }
        for (const key in proportionsKeyedByDate[date.toISODate()]) {
          if (!key.match(/date|isPrediction|sequencesCount|uncertain/gi)) {
            dayBin[key] = {
              ...proportionsKeyedByDate[date.toISODate()][key],
              ...dayBin[key]
            };
            dayBin.sequencesCount += dayBin[key].num;
          }
        }
      }

    });

  });

  processedData.predictionData = Object.values(predictionsKeyedByDate);
  processedData.predictionData.sort((a, b) => a.date.diff(b.date));

  //console.log(predictionsKeyedByDate);

  return processedData;

}

export function checkUncertainty(data, totalSequences) {

  //console.log('checkUncertainty', data, totalSequences);

  if (totalSequences > UNCERTAIN_THRESHOLD) { // Don't check countries with small numbers of samples

    let sample = data.slice(-6, -2); // try the prior 4 weeks for an average

    let avg = d3.mean(sample, d => d.sequencesCount);

    data.slice(-4).forEach(d => {

      //console.log(d);

      if (d.sequencesCount < (avg * UNCERTAIN_PCT_THRESHOLD)) {
      //console.log('uncertain', d);
        d.uncertain = true;
      }

    });

  }

}

function processVariants(variants, subvariants) {

  let subvariantLookup = {
    'Unassigned':{name:'Unassigned',variant:{name:'Unassigned'}}, // default
    // Recombinant -- 2 different parents, not handled by Wopr yet
    'Recombinant':{name:'Recombinant',variant:{name:'Recombinant'}}
  };

  //variants = variants.filter(v => v.count >= 10000);

  //console.log(variants);

  variants.forEach(v => {

    //v.lineages = v.lineages.filter(l => l.count >= 100);

    v.lineages.forEach(l => {
      l.variant = v;

      let tokens = l.name.split(".");

      l.topLevel = tokens[0];
      l.secondLevel = `${tokens[0]  }.${  tokens[1]}`;

      subvariantLookup[l.name] = l;

    });

    // if (v.name.indexOf('.') < 0) variantPrimaryLineages[v.name] = v.lineages[0].name;

    //v.lineages.sort(compareVariants);
  });


  // Pick up subvariants that have no variant, and bucket them with 'Unassigned'

  subvariants.forEach(sv => {
    if (!subvariantLookup[sv.name]) {
      if (sv.name.substring(0, 1) === "X") {
        subvariantLookup[sv.name] = {...subvariantLookup['Recombinant'], ...sv};
      } else {
        subvariantLookup[sv.name] = {...subvariantLookup['Unassigned'], ...sv};
      }
    }
  });

  // console.log(subvariantLookup);

  //variants.sort(compareVariants);

  return subvariantLookup;

}

export function getLineageToVariantLookup() {
  return lineageToVariantLookup;
}
export function getMostRecentDataDate() {
  return mostRecentDataDate;
}
export function getUpdateDate() {
  return updateDate;
}

// Simple shallow clones to make timeframe switching easier
export function setDataCopy(d) {

  let copy = {locations:[], variantSummary:[]};
  d.locations.forEach(c => {
    let o = {...c};
    o.data = [...o.data];
    copy.locations.push(o);
  });

  processedData = copy;

}
export function getDataCopy() {

  if (processedData) {

    let copy = {locations:[], variantSummary:[]};
    //console.log('getDataCopy', processedData);
    processedData.locations.forEach(c => {
      let o = {...c};
      o.data = [...o.data];
      copy.locations.push(o);
    });

    return copy;

  } else {
    return null;
  }

}

export function getVariantTotals(data, sequencesTotal) {

  let variantTotals = {};

  data.forEach(dataPt => {
    for (const key in dataPt) {
      if (!key.match(/date|sequencesCount|uncertain|isPrediction/gi)) {
        variantTotals[key] = variantTotals[key] || {num:0, pct:0, sequencesTotal:sequencesTotal};
        variantTotals[key].num += dataPt[key].num;
      }
    }

    for (const key in variantTotals) {
      variantTotals[key].pct = variantTotals[key].num / sequencesTotal;
    }
  });

  return variantTotals;

}

export function getSubvariantTotals(data, sequencesTotal) {

  let subvariantTotals = {};

  data.forEach(dataPt => {
    for (const key in dataPt) {
      if (!key.match(/date|sequencesCount|uncertain|isPrediction/gi)) {
        subvariantTotals[key] = subvariantTotals[key] || {num:0, pct:0, sequencesTotal:sequencesTotal};
        subvariantTotals[key].num += dataPt[key].num;
      }
    }

    for (const key in subvariantTotals) {
      subvariantTotals[key].pct = subvariantTotals[key].num / sequencesTotal;
    }
  });

  return subvariantTotals;

}

export function gatherOtherBucket(data, lineageThreshold) {
  // Post process lineages to create 'other' buckets

  let {underThresholdLineages} = getValidLineages(data, lineageThreshold);
  //console.log('preprocess', validLineages);

  data.locations.forEach(d => {
    // d.validLineages = validLineages;
    // d.underThresholdLineages = underThresholdLineages;
    // d.validVariants = validVariants;
    // d.underThresholdVariants = underThresholdVariants;
    // d.allVariants = allVariants;

    d.weeklyData.forEach(dataPt => {

      // Handle 'other' per variant

      // Clean up old ones first
      for (const key in dataPt) {
        if (key.match(/other/gi)) {
          delete dataPt[key];
        }
      }

      //dataPt.other = {num:0, pct:0, sequencesCount:0};
      let otherBuckets = {};
      underThresholdLineages.forEach(l => {

        //let lineageData = lineageToVariantLookup[l];

        // let otherBucket;
        // if (lineageData) {
        //   otherBucket = `other-${  lineageData.variant.name}`;
        // } else {
        //   otherBucket = 'other-Unassigned';
        // }

        let otherBucket = 'other';

        otherBuckets[otherBucket] = true;
        dataPt[otherBucket] = dataPt[otherBucket] || {num:0, pct:0, sequencesCount:0};

        if (dataPt[l] && dataPt[l].num) {
          dataPt[otherBucket].num += dataPt[l].num;
        }

      });

      Object.keys(otherBuckets).forEach(bucket => {
        dataPt[bucket].sequencesCount = dataPt.sequencesCount;
        dataPt[bucket].pct = dataPt[bucket].num / dataPt.sequencesCount;
      });
    });
  });

  return data;

}


export function getValidLineages(data, lineageThreshold) {
  let validLineagesKeyed = {};
  let allLineagesKeyed = {};

  // console.log(data);

  let validLineageDate = mostRecentDataDate.minus({months:4});

  data.locations.forEach(location => {

    // console.log(location.subvariantTotals);
    // console.log(location);


    let keys = setupKeys(location.weeklyData);

    let locationValidLineagesKeyed = {};
    let locationAllLineagesKeyed = {};

    let totalSequencesFiltered = location.sequencesFiltered;

    location.weeklyData.forEach(d => {

      let sequencesQualityCheck = (d.sequencesCount / totalSequencesFiltered) >= QUALITY_THRESHOLD;
      if (sequencesQualityCheck) {

        // console.log(d.date.toISODate(), d.date.diff(validLineageDate, ['months']));

        let diff = d.date.diff(validLineageDate, ['months']);
        if (diff.values.months >= 0) {

          keys.forEach(key => {
            if (d[key] && d[key].pct) {
              // Force 'other' keys to be valid for chart purposes
              if (key.match(/other/gi) || d[key].pct > lineageThreshold) {
                validLineagesKeyed[key] = true;
                locationValidLineagesKeyed[key] = true;
              }
              allLineagesKeyed[key] = true;
              locationAllLineagesKeyed[key] = true;
            }
          });

        }

      }

    });

    // Manually remove unassigned
    delete locationValidLineagesKeyed['Unassigned'];

    location.validLineages = Object.keys(locationValidLineagesKeyed) //.sort(compareLineageName);
    location.allLineages = Object.keys(locationAllLineagesKeyed);
    location.underThresholdLineages = location.allLineages.filter(key => {
      return !location.validLineages.includes(key);
    });

    let validVariantsKeyed = {};
    let allVariantsKeyed = {};
    let underThresholdVariantsKeyed = {};

    location.validLineages.forEach(l => {
      if (lineageToVariantLookup[l] && lineageToVariantLookup[l].variant) {
        let variant = lineageToVariantLookup[l].variant;
        validVariantsKeyed[variant.name] = true;
      }
    });
    location.allLineages.forEach(l => {
      if (lineageToVariantLookup[l] && lineageToVariantLookup[l].variant) {
        let variant = lineageToVariantLookup[l].variant;
        allVariantsKeyed[variant.name] = true;
      }
    });
    location.underThresholdLineages.forEach(l => {
      if (lineageToVariantLookup[l] && lineageToVariantLookup[l].variant) {
        let variant = lineageToVariantLookup[l].variant;
        underThresholdVariantsKeyed[variant.name] = true;
      }
    });

    location.validVariants = Object.keys(validVariantsKeyed).sort(compareLineageName);
    location.allVariants = Object.keys(allVariantsKeyed).sort(compareLineageName);
    location.underThresholdVariants = Object.keys(underThresholdVariantsKeyed).sort(compareLineageName);

  });

  // Manually remove unassigned
  delete validLineagesKeyed['Unassigned'];

  let validLineages = Object.keys(validLineagesKeyed);
  let allLineages = Object.keys(allLineagesKeyed);
  let underThresholdLineages = allLineages.filter(key => {
    return !validLineages.includes(key);
  });

  data.validLineages = validLineages;
  data.allLineages = allLineages;
  data.underThresholdLineages = underThresholdLineages;



  let validVariantsKeyed = {};
  let allVariantsKeyed = {};
  let underThresholdVariantsKeyed = {};

  validLineages.forEach(l => {
    if (lineageToVariantLookup[l] && lineageToVariantLookup[l].variant) {
      let variant = lineageToVariantLookup[l].variant;
      validVariantsKeyed[variant.name] = true;
    }
  });
  allLineages.forEach(l => {
    if (lineageToVariantLookup[l] && lineageToVariantLookup[l].variant) {
      let variant = lineageToVariantLookup[l].variant;
      allVariantsKeyed[variant.name] = true;
    }
  });
  underThresholdLineages.forEach(l => {
    if (lineageToVariantLookup[l] && lineageToVariantLookup[l].variant) {
      let variant = lineageToVariantLookup[l].variant;
      underThresholdVariantsKeyed[variant.name] = true;
    }
  });

  let validVariants = Object.keys(validVariantsKeyed).sort(compareLineageName);
  let allVariants = Object.keys(allVariantsKeyed).sort(compareLineageName);
  let underThresholdVariants = Object.keys(underThresholdVariantsKeyed).sort(compareLineageName);


  data.validVariants = validVariants;
  data.allVariants = allVariants;
  data.underThresholdVariants = underThresholdVariants;

  // console.log(data);
  // console.log('validLineages', validLineages);
  // console.log('underThresholdLineages', underThresholdLineages);
  // console.log('validVariants', validVariants);
  // console.log('underThresholdVariants', underThresholdVariants);

  return {validLineages, allLineages, underThresholdLineages, validVariants, allVariants, underThresholdVariants};
}

export function getSubvariantsGroupedByVariants(data, lineageThreshold) {

  let {validLineages, underThresholdLineages} = getValidLineages(data, lineageThreshold);

  let groupedByVariants = {};
  let groupedByVariantsFilteredByPredictions = {};
  let allLocationsFilteredByPredictions = {};

  validLineages.forEach(lineage => {
    //return lineageToVariantLookup[lineage];
    let lineageData = lineageToVariantLookup[lineage];
    if (lineageData && lineageData.variant && lineageData.variant.name !== "Unassigned") {
      groupedByVariants[lineageData.variant.name] = groupedByVariants[lineageData.variant.name] || [];
      groupedByVariants[lineageData.variant.name].push(lineageData);

      data.locations.forEach(l => {
        if (l.predictionSubvariants.includes(lineage)) {
          groupedByVariantsFilteredByPredictions[lineageData.variant.name] = groupedByVariantsFilteredByPredictions[lineageData.variant.name] || [];
          // No dupes
          if (!groupedByVariantsFilteredByPredictions[lineageData.variant.name].includes(lineageData)) {
            groupedByVariantsFilteredByPredictions[lineageData.variant.name].push(lineageData);
          }

          allLocationsFilteredByPredictions[lineage] = true;
        }
      });

    } else if (lineageData) {
      groupedByVariants['Unassigned'] = groupedByVariants['Unassigned'] || [];
      groupedByVariants['Unassigned'].push(lineageData);
    }


  });

  // console.log(groupedByVariants);
  // console.log('allLocationsFilteredByPredictions', allLocationsFilteredByPredictions);

  // Time to sort, need to sort by basic string keys and then rebuild the array
  for (const variant in groupedByVariants) {
    let subvariantKeys = groupedByVariants[variant].map(sv => sv.name).filter(sv => sv); // filter blanks
    subvariantKeys.sort(compareLineageName);

    let refSubvariants = [...groupedByVariants[variant]];

    groupedByVariants[variant] = subvariantKeys.map(k => {
      return refSubvariants.find(sv => {
        return sv.name === k;
      });
    });
  }

  // Sort the predicted ones
  for (const variant in groupedByVariantsFilteredByPredictions) {
    let subvariantKeys = groupedByVariantsFilteredByPredictions[variant].map(sv => sv.name).filter(sv => sv); // filter blanks
    subvariantKeys.sort(compareLineageName);

    let refSubvariants = [...groupedByVariantsFilteredByPredictions[variant]];

    groupedByVariantsFilteredByPredictions[variant] = subvariantKeys.map(k => {
      return refSubvariants.find(sv => {
        return sv.name === k;
      });
    });
  }

  // console.log(groupedByVariantsFilteredByPredictions);

  let groupedByVariantsOthers = {};
  let groupedByVariantsOthersFilteredByPredictions = {};

  underThresholdLineages.forEach(lineage => {
    //return lineageToVariantLookup[lineage];
    let lineageData = lineageToVariantLookup[lineage];
    //console.log(lineage, lineageData);
    if (lineageData && lineageData.variant && lineageData.variant.name !== "Unassigned") {
      groupedByVariantsOthers[lineageData.variant.name] = groupedByVariantsOthers[lineageData.variant.name] || [];
      groupedByVariantsOthers[lineageData.variant.name].push(lineageData);

      groupedByVariantsOthersFilteredByPredictions[lineageData.variant.name] = groupedByVariantsOthersFilteredByPredictions[lineageData.variant.name] || [];
      groupedByVariantsOthersFilteredByPredictions[lineageData.variant.name].push(lineageData);
    } else if (lineageData) {
      groupedByVariantsOthers['Unassigned'] = groupedByVariantsOthers['Unassigned'] || [];
      groupedByVariantsOthers['Unassigned'].push(lineageData);

      groupedByVariantsOthersFilteredByPredictions['Unassigned'] = groupedByVariantsOthersFilteredByPredictions['Unassigned'] || [];
      groupedByVariantsOthersFilteredByPredictions['Unassigned'].push(lineageData);
    }
  });

  // groupedByVariantsOthersFilteredByPredictions = {...groupedByVariantsOthers};
  // Add in any subvariants that were filtered out of predictions
  validLineages.forEach(lineage => {
    //return lineageToVariantLookup[lineage];
    let lineageData = lineageToVariantLookup[lineage];
    if (lineageData && lineageData.variant && lineageData.variant.name !== "Unassigned") {

      // data.locations.forEach(l => {
      // if (l.predictionSubvariants.includes(lineage)) {
      //   groupedByVariantsFilteredByPredictions[lineageData.variant.name] = groupedByVariantsFilteredByPredictions[lineageData.variant.name] || [];
      //   // No dupes
      //   if (!groupedByVariantsFilteredByPredictions[lineageData.variant.name].includes(lineageData)) {
      //     groupedByVariantsFilteredByPredictions[lineageData.variant.name].push(lineageData);
      //   }
      // }

      // console.log(lineage, allLocationsFilteredByPredictions[lineage]);

      if (!allLocationsFilteredByPredictions[lineage]) {
        // console.log('add to others', lineage, lineageData);
        groupedByVariantsOthersFilteredByPredictions[lineageData.variant.name] = groupedByVariantsOthersFilteredByPredictions[lineageData.variant.name] || [];
        groupedByVariantsOthersFilteredByPredictions[lineageData.variant.name].push(lineageData);
      }
      // });

    }


  });


  // console.log('groupedByVariants', groupedByVariants);
  // console.log('groupedByVariantsOthers', groupedByVariantsOthers);
  //
  // console.log('groupedByVariantsFilteredByPredictions', groupedByVariantsFilteredByPredictions);
  // console.log('groupedByVariantsOthersFilteredByPredictions', groupedByVariantsOthersFilteredByPredictions);

  return {
    groupedByVariants,
    groupedByVariantsOthers,
    groupedByVariantsFilteredByPredictions,
    groupedByVariantsOthersFilteredByPredictions
  };
}

export function setupKeys(data) {

  let keysKeyed = {};
  data.forEach(d => {
    for (const k in d) {
      //console.log(d);
      if (!k.match(/date|sequencesCount|uncertain|isprediction/gi)) {
        if (!keysKeyed[k]) {
          keysKeyed[k] = true;
        }
      }
    }
  });


  let keys = Object.keys(keysKeyed);

  //Add in missing keys
  data.forEach(d => {
    //console.log(d);
    keys.forEach(k => {
      if (!d[`${k  }`]) {
        d[`${k  }`] = {num:0, pct:0};
      }
    });
  });

  //keys.sort(compareLineageName).reverse();

  //console.log('keys',keys);

  return keys;

}

export function sortKeys(keys, allVariants) {

  /*
  To sort the keys, we need to consider:
    Parent variants (Omicron, Delta, etc)
      A logical sort of subvariants: BA.1, BA.2, BA.2.1, BA.5, BE.1, etc
      'Other' buckets in each variant
    An unassigned bucket
  All, such that old variants and subvariants appear toward the top of the chart,
    and Unassigned is at the bottom
  */


  let sortedKeys = [];

  allVariants.forEach(variant => {
    let variantKeys = keys.filter(key => {
      let lineageData = lineageToVariantLookup[key];
      if (lineageData && key) {
        return lineageData.variant.name === variant;
      }
      return false;
    });

    variantKeys.sort(compareLineageName); // Sort the valid keys first

    // Now, tack the 'other' bucket on the end if it exists
    if (keys.includes(`other-${ variant }`)) {
      variantKeys.push(`other-${ variant }`);
    }

    sortedKeys = [...sortedKeys, ...variantKeys];

  });



  sortedKeys.reverse();

  sortedKeys.push('other');


  // Force sort the unassigned items to the end of the array

  let unassignedIndex = sortedKeys.indexOf("Unassigned");
  if (unassignedIndex > -1) {
    sortedKeys.splice(unassignedIndex, 1); // get rid of the key in its current spot
    sortedKeys.push("Unassigned"); // move it to the end of the array
  }

  unassignedIndex = sortedKeys.indexOf("other-Unassigned");
  if (unassignedIndex > -1) {
    sortedKeys.splice(unassignedIndex, 1); // get rid of the key in its current spot
    sortedKeys.push("other-Unassigned"); // move it to the end of the array
  }

  return sortedKeys;
}

export let compareLineageName = (a, b)=>{
  let aTokens = a.split('.'),
    bTokens = b.split('.'),
    aRootLength = a[0].length,
    bRootLength = b[0].length,
    // lineage AB comes after Z
    diff = aRootLength - bRootLength;
  if (diff === 0) {
    if (a !== b) {
      // do the roots differ?
      diff = a < b ? -1 : 1;
    } else {
      // loop through the remaining tokens and compare
      let limit = Math.min(aTokens.length, bTokens.length);
      for (let i = 1; i < limit && diff !== 0; i++) {
        diff = parseInt(aTokens[i]) - parseInt(bTokens[i]);
      }
      if (diff === 0) {
        // case like BA.2 vs BA.2.12.1
        diff = aTokens.length - bTokens.length;
      }
    }
  }
  return diff;
}
